import React from "react";

interface CactusLabelInputProps {
    labelTitle: string;
    labelStyle?: any;
    inputAttributes: any;
    errorMessage?: string | null;
}

const CactusLabelInput = (props: CactusLabelInputProps) => {

    const _showErrors = () => {

        if(props.errorMessage === null || props.errorMessage?.length === 0) return null;

        return (<div className="mt-2 form__invalid-feedback font-weight-bold">{props.errorMessage}</div>);

    }
    
    const customClasses = props.inputAttributes.classProps ? props.inputAttributes.classProps : ''
    
    return(
        <label className="w-100">
            <span className="form__label" style={props.labelStyle}>{props.labelTitle}</span>
            <input 
                {...props.inputAttributes}
                className={`w-100 form-control--dark mt-2 ${customClasses}`}
            />
            {_showErrors()}
        </label>
    );
};

export default React.memo(CactusLabelInput);
